export default "__VITE_ASSET__BwilMSpe__"